import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../../../styles/dashboardTheme.css";
import "../../../styles/managementTheme.css";
import SecretariaDashboard from "./pages/SecretariaDashboard";

export default function DashboardSecretaria() {
  return <SecretariaDashboard />;
}
